import { Grid } from "@material-ui/core";
import { TextInput, required } from "react-admin";
import { PlatformWithOrderCheckboxGroupInput } from "../../component/platform-components";
import { RegionCheckboxGroupInput } from "../../component/region-components";
import { ShelfDateTimeInput } from "./shelf-date-time-input";
import { TemplateSelectInput } from "./template-select-input";

export const ScoopPlusForm = (props) => {
  const rest = props.rest;

  // reset the form into initial values

  return (
    <Grid container spacing={1} fullWidth>
      <Grid container spacing={1} fullWidth>
        <Grid item sm={12} md={6}>
          <TextInput label="Row title in TC" source="title_tc" validate={required()} fullWidth />
        </Grid>
        <Grid item sm={12} md={6}>
          <TextInput label="Row title in EN" source="title_en" validate={required()} fullWidth />
        </Grid>
      </Grid>

      <Grid item sm={12} md={12}>
        <TemplateSelectInput layouts={["scoopplus"]} defaultValue={"scoopplus"} isRequired={true} />
      </Grid>

      <Grid item sm={12} md={12}>
        <PlatformWithOrderCheckboxGroupInput fullWidth {...rest} />
      </Grid>

      <Grid item sm={12} md={12}>
        <RegionCheckboxGroupInput noDefaultValue={true} fullWidth />
      </Grid>

      <ShelfDateTimeInput />
    </Grid>
  );
};
